import { Component, OnInit } from '@angular/core';
import { Sidebar } from '../../particles/sidebar/sidebar';
import { RouterOutlet } from '@angular/router';
import { AuthService } from 'features/auth/auth.service';
import { FirebaseService } from 'core/services/firebase.service';
import { UtilsService } from 'core/services/utils.service';
import { RegisterFCMTokenRequestDTO } from 'features/auth/dtos/register-fcm-token-request.dto';
import { Icon } from 'shared/components/particles/icon/icon';
import { StorageService } from 'core/services/storage.service';

@Component({
  selector: 'app-main-layout',
  imports: [
    Sidebar,
    RouterOutlet,
    Icon
  ],
  providers: [
    AuthService
  ],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout implements OnInit {
  constructor(
    private authService: AuthService,
    private firebaseService: FirebaseService,
    private utilService: UtilsService,
    public storageService: StorageService
  ) { }

  initDeviceWithFirebase() {
    this.firebaseService.requestPermissionAndGetToken().then((token) => {
      if (token) {
        const body = new RegisterFCMTokenRequestDTO(
          {
            deviceInfo: this.utilService.getDeviceName(),
            token
          });
        this.authService.registerFCMToken(body).subscribe()
      }
    })
  }

  handleShowSidebar() {
    if (window.innerWidth <= 1024) {
      this.storageService.displaySidebar();
    }
  }

  handleHideSidebar() {
    if (window.innerWidth <= 1024) {
      this.storageService.hideSidebar();
    }
  }

  ngOnInit(): void {
    this.initDeviceWithFirebase();
  }
}
